export const ADMIN_TOKEN_KEY = 'pp_admin_token'
export const ADMIN_USER_KEY = 'pp_admin_user'

export type AdminUser = {
  id?: number
  email?: string
  displayName?: string
  role?: string
}

export type AdminClient = {
  id: number
  display_name?: string
  email?: string
  email_verified?: boolean
  status?: string
  demo_account_count?: number
  latest_balance?: number | null
  registered_at?: string
  last_login_at?: string | null
  phone?: string
  country?: string
}

export type AdminTradingAccount = {
  id: number
  mt5_login?: number
  mt5Login?: number
  mt5_login_masked?: string
  server?: string
  mode?: string
  currency?: string
  balance?: number
  equity?: number
  status?: string
  client_id?: number
  sync_state?: string | null
  last_sync_at?: string | null
  created_at?: string | null
  archived_at?: string | null
}

export type AdminDeposit = {
  id: number
  reference?: string
  amount?: string | number
  currency?: string
  status?: string
  provider?: string
  created_at?: string
  completed_at?: string | null
  client_id?: number
  client_email?: string
  client_name?: string
  trading_account_id?: number
  mt5_login_masked?: string
  has_screenshot?: boolean
  txid_masked?: string
  asset?: string
  network?: string
}

export type AdminTimelineEvent = {
  event_type?: string
  timestamp?: string
  actor_type?: string
  actor_id?: number | string | null
  account_id?: number | null
  mt5_login_masked?: string | null
  description?: string
  result?: string
  metadata?: Record<string, unknown>
}

export const adminNav = [
  { to: '/admin', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/admin/clients', label: 'Clients', icon: 'clients' },
  { to: '/admin/trading-accounts', label: 'Trading Accounts', icon: 'accounts' },
  { to: '/admin/balance', label: 'MT5 Balance', icon: 'balance' },
  { to: '/admin/deposits', label: 'Deposits', icon: 'deposits' },
  { to: '/admin/withdrawals', label: 'Withdrawals', icon: 'withdrawals' },
  { to: '/admin/ib', label: 'IB / Sub-admins', icon: 'ib' },
  { to: '/admin/notifications', label: 'Notifications', icon: 'notifications' },
  { to: '/admin/transactions', label: 'Transactions', icon: 'transactions' },
  { to: '/admin/audit', label: 'Audit', icon: 'audit' },
  { to: '/admin/system', label: 'System Backup', icon: 'system' },
  { to: '/admin/settings', label: 'Settings', icon: 'settings' },
] as const
